const Code = {
  defaultProps: { colorScheme: "blackAlpha" },
};

export default Code;
